import { Component, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { environment } from '../environments/environment';
import { SharedService } from './shared/services/shared.service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  //title = 'sette-clipping-frontend';

  // TO DO check if unfinished uploads are pending
  // @HostListener('window:beforeunload', [ '$event' ])
  // beforeUnloadHandler(event: any) {
  //   event.returnValue = 'Your data will be lost!';
  // }
  constructor(
    private sharedService: SharedService,
    private router: Router,
    private ga: GoogleAnalyticsService
  ) {
    this.sharedService.loadResellerSettings();
  }

  ngOnInit() {
		const reseller = environment.reseller;
		const link = document.createElement('link');
		link.type = 'image/x-icon';
		link.rel = 'icon';
		link.href = `${reseller.assets}/images/favicon.ico`;
		document.getElementsByTagName('head')[0].appendChild(link);

		const title = document.getElementById('main-page-title');
		const text = document.createTextNode(reseller.name);
		if (title) {
			title.appendChild(text);
		}

		this.ga.initializeGA();

		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe((event: NavigationEnd) => {
			this.ga.trackPageView(document.title, event.urlAfterRedirects);
		});
	}
}
